import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import AboutSection from "../components/sections/AboutSection";
import ServicesSection from "../components/sections/ServicesSection";
import CalculatorSection from "../components/sections/CalculatorSection";
import SecuritySection from "../components/sections/SecuritySection";
import ProcessSection from "../components/sections/ProcessSection";
import TestimonialsSection from "../components/sections/TestimonialsSection";
import FaqSection from "../components/sections/FaqSection";
import ContactSection from "../components/sections/ContactSection";

function scrollToHashTarget() {
  const hash = window.location.hash.replace("#", "");
  if (!hash) return;
  const el = document.getElementById(hash);
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

export default function Home() {
  useEffect(() => {
    const timer = setTimeout(scrollToHashTarget, 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#050A1F] text-white">
      <Navbar />
      <Hero />
      <AboutSection />
      <div className="hairline mx-auto max-w-7xl" />
      <ServicesSection />
      <CalculatorSection />
      <SecuritySection />
      <ProcessSection />
      <TestimonialsSection />
      <FaqSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
